





































































































import { Mixins, Component, Prop } from "vue-property-decorator";
import { BvTableFieldArray, BvTableCtxObject } from "bootstrap-vue";
import { VIPCapabilityRequestRefreshTableMixin } from "@/mixins/VIPCapabilityRequestMixin";
import {
	VIPCapabilityRequestRest,
	VipCapabilityRequestStatus,
	getVipCapabilityRequestStatusList,
} from "@/loader";
import CapabilityRequestStatusBadge from "./CapabilityRequestStatusBadge.vue";
import dayjs, { ConfigType } from 'dayjs';

@Component({
	components: {
		CapabilityRequestStatusBadge
	}
})
export default class CapabilityRequestsTable extends Mixins(VIPCapabilityRequestRefreshTableMixin) {
	@Prop({ type: String, default: null })
	public status!: VipCapabilityRequestStatus | null;

	public statuses: VipCapabilityRequestStatus[] = [];

	public get capabilityRequestStatuses() {
		return getVipCapabilityRequestStatusList();
	}

	public get fields(): BvTableFieldArray {
		let fields: BvTableFieldArray = [];
		fields.push({
			key: "date",
			label: "Demande",
			sortable: true,
			formatter(value: ConfigType | null) {
				let d = dayjs(value || undefined);
				return d.isValid() ? d.format("L") : ""
			}
		});
		fields.push({
			key: "status",
			label: "Statut",
		});
		fields.push({
			key: "capabilities",
			label: "IPs",
			sortable: false,
		});
		return fields;
	}

	public getCapabilityRequests(context: BvTableCtxObject, callback: Function) {
		VIPCapabilityRequestRest.list({
			page: context.currentPage,
			per_page: context.perPage,
			search: context.filter?.toString() || undefined,
			// @ts-ignore
			orderby: context.sortBy || undefined,
			order: context.sortDesc ? "DESC" : "ASC",
			// @ts-ignore
			status: !this.hideFilters ? this.statuses : (this.status || undefined),
			options: {
				capabilities: {
					certificates: {
						certificate: {
							project: true
						},
					},
				},
			},
		}).then(result => {
			this.setResult(callback, result);
		});
		return null;
	}
}
